export default __webpack_public_path__ + "60a1b98f85c3a1a505127ca53e8df85c.png";